<section>
  <header [ngStyle]="{'height': systemType === 'SAFETRACE' ? '14vh' : '7vh'}">
    <div class="enterprise-logo">
      <img
        [src]="systemType !== 'SAFETRACE' ? '../../../assets/images/qima-logo.png' : '../../../assets/images/localiza-logo.png'"
        alt="Enterprise Logo" alt="Qima Logo">
    </div>
  </header>

  <div class="download-container">
    <button class="button" (click)="downloadReport()"> Download
      <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#F3F3F3">
        <path
          d="M480-336 288-528l51-51 105 105v-342h72v342l105-105 51 51-192 192ZM263.72-192Q234-192 213-213.15T192-264v-72h72v72h432v-72h72v72q0 29.7-21.16 50.85Q725.68-192 695.96-192H263.72Z" />
      </svg>
    </button>
  </div>

  <div class="content-area">
    <div class="report-header">
      <div class="container">
        @if(systemType === 'SAFETRACE') {
        <div class="enterprise-logo-container">
          <img src="../../../assets/images/localiza-logo.png" alt="Enterprise Logo">
        </div>
        }

        <div class="texts">
          <div class="title">
            <h4> Certificado de Conformidade </h4>
          </div>
        </div>

        @if(systemType !== 'SAFETRACE') {
        <div class="enterprise-logo-container">
          <img src="../../../assets/images/qima-logo.png" alt="Qima Logo">
        </div>
        }
      </div>
    </div>

    <div class="main">
      <app-minerva-report-table-version (handleReportData)="saveReportData($event)"
        (handleCorporateName)="saveCorporateName($event)"> </app-minerva-report-table-version>
    </div>

    <div class="report-footer" style="margin-top: 15%;">
      @if(systemType !== 'SAFETRACE') {
      <img src="../../../assets/images/safe-track.png" alt="Safe Track">
      <span> {{ enterpriseEmail }} </span>
      <span style="display: flex; align-items: center; gap: 3px">
        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 -960 960 960" fill="#C92026">
          <path
            d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" />
        </svg>
        {{ enterpriseAddress }}
      </span>
      }
    </div>
  </div>
</section>